import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {connect} from '@modifi/redux'
import {aShowDialog} from '@modifi/plugin-dialogs'
import {compose} from 'ramda'
import {Container, withResponsiveHelper} from '@modifi/ui'

import {ctaMapping, iconMapping} from '../constants'
import {DIALOG_IFRAME} from '.'
import {DefaultComponentWrapper} from '../common'

const propTypes = {
  showDialog: PropTypes.func.isRequired,
  link: PropTypes.string,
  ctaType: PropTypes.string,
  ctaText: PropTypes.string,
  ctaIcon: PropTypes.string,
  isMdOrSmaller: PropTypes.bool.isRequired,
  backgroundColor: PropTypes.string,
}
const defaultProps = {
  link: '',
  ctaType: 'primary',
  ctaText: '',
  ctaIcon: 'none',
  backgroundColor: undefined,
}

export type IframeButtonProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const IframeButton: React.FC<IframeButtonProps> = ({
  showDialog,
  link,
  ctaType,
  ctaText,
  ctaIcon,
  isMdOrSmaller,
  backgroundColor,
}) => {
  const Button = ctaMapping[ctaType || 'primary']
  const Icon = ctaIcon && ctaIcon !== 'none' && iconMapping[ctaIcon]

  const handleClick = () => {
    if (isMdOrSmaller) window.open(link, '_newtab')
    else {
      showDialog(DIALOG_IFRAME, {link, title: ctaText})
    }
  }
  return (
    <DefaultComponentWrapper backgroundColor={backgroundColor} padding={0}>
      <Container>
        <Button icon big data-target={link} onClick={handleClick}>
          {Icon ? (
            <>
              <Icon height={25} width={20} />
              &nbsp;
            </>
          ) : null}
          {ctaText}
        </Button>
      </Container>
    </DefaultComponentWrapper>
  )
}

IframeButton.propTypes = propTypes

IframeButton.defaultProps = defaultProps

const mapStateToProps = (
  state: any,
  ownProps: {link: string; ctaType: string; ctaText: string; ctaIcon: string}
) => ({
  ...ownProps,
})

const mapDispatchToProps = {
  showDialog: aShowDialog,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  withResponsiveHelper(IframeButton)
)
